import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';
import { getProcessEnvUrl } from '../../utils/getUrl';

type KeycloakStore = {
  isLegacyLogin: boolean | null;
  isLegacyLoginLoading: boolean;
  setIsLegacyLogin: (value: boolean) => void;
  setIsLegacyLoginLoading: (value: boolean) => void;
};

type KeycloakSettingsResponse = {
  keycloakAuth: boolean;
};

const LEGACY_LOGIN_API = 'GATEWAY_URL';

export const keycloakStore = createStore<KeycloakStore>()((set) => ({
  isLegacyLogin: null,
  isLegacyLoginLoading: true,
  setIsLegacyLogin: (value) => set({ isLegacyLogin: value }),
  setIsLegacyLoginLoading: (value) => set({ isLegacyLoginLoading: value }),
}));

export const useKeycloakStore = <T>(selector: (state: KeycloakStore) => T) =>
  useStore(keycloakStore, selector);

const fetchKeycloakSettings = async (): Promise<KeycloakSettingsResponse> => {
  const url = getProcessEnvUrl(LEGACY_LOGIN_API);
  const response = await fetch(`${url}/webapi/keycloak/settings`);

  if (!response.ok) {
    throw new Error(
      `Failed to fetch /keycloak/settings from ${LEGACY_LOGIN_API}`,
    );
  }

  return response.json();
};

let bootstrapPromise: Promise<void> | null = null;

export const bootstrapKeycloakStore = async () => {
  if (bootstrapPromise) {
    return bootstrapPromise;
  }

  bootstrapPromise = (async () => {
    const store = keycloakStore.getState();

    store.setIsLegacyLoginLoading(true);

    try {
      const data = await fetchKeycloakSettings();
      store.setIsLegacyLogin(!data.keycloakAuth);
    } catch {
      store.setIsLegacyLogin(true);
    } finally {
      store.setIsLegacyLoginLoading(false);
    }
  })();

  return bootstrapPromise;
};
